module.exports = __webpack_public_path__ + "fce4733727399dc78fbe54c8a74e69e2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/cube_black.png
 ** module id = 1049
 ** module chunks = 0
 **/